import React from 'react';
export function PrivacyHeader() {
  return <header className="w-full bg-[#b8d8d8] border-b border-[#0f3f4a]/10" data-id="element-16">
      <div className="max-w-4xl mx-auto px-6 py-8 flex items-center justify-center" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/4QWUxbK1618fMsLx25bfjd/MASCOTAS.png" alt="La Conexión Cuántica" className="h-24 sm:h-28 w-auto object-contain" data-id="element-18" />
      </div>
    </header>;
}